export function getNadoDepositErrorMessage(details: string): string {
  const normalizedDetails = details.toLowerCase();

  if (details.includes('Wallet not connected')) {
    return 'Please refresh the page or reconnect your wallet';
  }

  if (
    details.includes('Privy sponsored deposit is not available') ||
    details.includes('Privy sponsored approval is not available')
  ) {
    return 'Wallet sponsorship is not ready - reconnect and retry';
  }

  if (
    normalizedDetails.includes('total cost') &&
    normalizedDetails.includes('exceeds the balance')
  ) {
    return 'Add ETH on the source chain for approval and bridge gas, then retry';
  }

  if (
    normalizedDetails.includes('insufficient funds for gas') ||
    normalizedDetails.includes('gas * price + value') ||
    normalizedDetails.includes('gas fee')
  ) {
    return 'Add ETH on the source chain for approval and bridge gas, then retry';
  }

  if (details.includes('insufficient funds for transfer')) {
    return 'Insufficient funds for transfer + gas tx';
  }

  if (
    details.includes('User rejected') ||
    details.includes('user rejected') ||
    details.includes('User denied') ||
    details.includes('user denied')
  ) {
    return 'Transaction rejected by wallet';
  }

  if (details.includes('nonce')) {
    return 'Transaction nonce error - try again';
  }

  if (details.includes('timeout') || details.includes('Timeout')) {
    return 'Request timed out - check your connection';
  }

  return 'Transaction failed - see details';
}
